(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 911:
/***/ (() => {



/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_FilePicker)
});

;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
;// external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// ./src/_shared/_helpers/randomNum.ts
/**
 * Generates a random number
 *
 * @param {number} [min=10000] - the minimum number for generatation
 * @param {number} [max=99999] - the maxiumum number for generatation
 *
 * @returns {number} random number between min and max
 */
var randomNum = function randomNum() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  var randomNumber = Math.random() * (max - min) + min;
  return Math.floor(randomNumber);
};
/* harmony default export */ const _helpers_randomNum = (randomNum);
;// external "@babel/runtime/helpers/toConsumableArray"
const toConsumableArray_namespaceObject = require("@babel/runtime/helpers/toConsumableArray");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_namespaceObject);
;// ./src/_shared/_helpers/isValidErrorMessageProp.ts


var allowedElementTypes = ['span', 'string', 'Symbol(react.fragment)'];
var _parseChildrenToFindNonSpanElements = function parseChildrenToFindNonSpanElements(children, listOfElements) {
  external_react_namespaceObject.Children.map(children, function (child) {
    if (! /*#__PURE__*/(0,external_react_namespaceObject.isValidElement)(child)) {
      return '';
    }
    if (child.props.children) {
      var props = {
        children: _parseChildrenToFindNonSpanElements(child.props.children, listOfElements)
      };
      child = /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(child, props);
    }
    listOfElements.push(child.type.toString());
    return child.type.toString();
  });
  return listOfElements;
};
var isValidErrorMessageProp = function isValidErrorMessageProp(children) {
  var listOfElements = [];
  _parseChildrenToFindNonSpanElements(children, listOfElements);
  var listOfDisallowedElementsForErrorMessaging = listOfElements.filter(function (elementType) {
    return !allowedElementTypes.includes(elementType);
  });
  if (listOfDisallowedElementsForErrorMessaging.length) {
    listOfDisallowedElementsForErrorMessaging = listOfDisallowedElementsForErrorMessaging.map(function (element) {
      return "<".concat(element, ">");
    });
    var disallowedElementsForErrorMessagingAsAString = toConsumableArray_default()(new Set(listOfDisallowedElementsForErrorMessaging)).join(', ');
    var errorMessage = listOfDisallowedElementsForErrorMessaging.length > 1 ? "Elements ".concat(disallowedElementsForErrorMessagingAsAString, " are not allowed") : "Element ".concat(disallowedElementsForErrorMessagingAsAString, " is not allowed");
    return {
      isValidErrorMessage: false,
      invalidErrorMessagePropErrorText: errorMessage
    };
  }
  return {
    isValidErrorMessage: true,
    invalidErrorMessagePropErrorText: ''
  };
};
var throwErrorIfInvalidErrorMessageProp = function throwErrorIfInvalidErrorMessageProp(errorMessageProp, errorMessagePropName) {
  var _isValidErrorMessageP = isValidErrorMessageProp(errorMessageProp),
    isValidErrorMessage = _isValidErrorMessageP.isValidErrorMessage,
    invalidErrorMessagePropErrorText = _isValidErrorMessageP.invalidErrorMessagePropErrorText;
  if (!isValidErrorMessage) {
    throw new Error("".concat(invalidErrorMessagePropErrorText, " for ").concat(errorMessagePropName, ". Please provide a string or a span element. Nested spans are allowed for accessibility purposes."));
  }
};

;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/FilePicker/FilePicker.tsx



var _excluded = ["autoFocus", "className", "label", "name", "events", "helpText", "emptyInputText", "invalidInputText", "accept", "capture", "multiple", "invalid", "required", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





/**
 * File Picker allows users to select one or more files to send in a form submission.
 *
 * [View the File Picker pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/File+Picker)
 *
 * @version 1.0.0
 */

var FilePicker = /*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(function (props, forwardedRef) {
  var id = props.id || "ableFilePicker".concat(_helpers_randomNum());
  var autoFocus = props.autoFocus,
    className = props.className,
    label = props.label,
    name = props.name,
    events = props.events,
    helpText = props.helpText,
    _props$emptyInputText = props.emptyInputText,
    emptyInputText = _props$emptyInputText === void 0 ? 'Required Field.' : _props$emptyInputText,
    _props$invalidInputTe = props.invalidInputText,
    invalidInputText = _props$invalidInputTe === void 0 ? 'Invalid Input.' : _props$invalidInputTe,
    accept = props.accept,
    capture = props.capture,
    multiple = props.multiple,
    invalid = props.invalid,
    required = props.required,
    value = props.value,
    other = objectWithoutProperties_default()(props, _excluded);
  var inputRef = (0,external_react_namespaceObject.useRef)();
  (0,external_react_namespaceObject.useImperativeHandle)(forwardedRef, function () {
    return inputRef.current;
  });
  var _useState = (0,external_react_namespaceObject.useState)(true),
    _useState2 = slicedToArray_default()(_useState, 2),
    isInputEmpty = _useState2[0],
    setIsInputEmpty = _useState2[1];
  var classes = classnames_default()('able-FilePicker', className);
  var helpTextId = "".concat(id, "__help-text");
  var errorTextId = "".concat(id, "__error-text");
  (0,external_react_namespaceObject.useEffect)(function () {
    var myRef = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
    setIsInputEmpty((myRef === null || myRef === void 0 ? void 0 : myRef.value.length) === 0);
  }, [invalid]);
  var errorText = function errorText() {
    if (invalidInputText) {
      throwErrorIfInvalidErrorMessageProp(invalidInputText, 'invalidInputText');
    }
    if (invalidInputText && isInputEmpty) {
      return emptyInputText;
    }
    if (invalidInputText && !isInputEmpty) {
      return invalidInputText;
    }
    return emptyInputText;
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", _objectSpread(_objectSpread({
    className: classes
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("label", {
      htmlFor: id,
      children: [label, " ", required ? '' : '(optional)']
    }), helpText ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      id: helpTextId,
      children: helpText
    }) : null, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("input", _objectSpread(_objectSpread(_objectSpread({
      ref: inputRef,
      value: value,
      name: name || id,
      id: id,
      type: "file"
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: autoFocus,
      accept: accept,
      capture: capture,
      multiple: multiple
    }, invalid ? {
      'aria-invalid': true
    } : null), required ? {
      'aria-required': 'true'
    } : {}), events)), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      id: errorTextId,
      children: [" ", errorText(), " "]
    })]
  }));
});
/* harmony default export */ const FilePicker_FilePicker = (FilePicker);
// EXTERNAL MODULE: ./src/FilePicker/FilePicker.scss
var src_FilePicker_FilePicker = __webpack_require__(911);
;// ./src/FilePicker/index.ts


/* harmony default export */ const src_FilePicker = (FilePicker_FilePicker);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});